module.exports = __webpack_public_path__ + "img/27.99316a2e.png";